var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liu"},[_c('mt-button',{on:{"click":_vm.onClick}},[_vm._v("点这里")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }